import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { pencentage } from '../../utils/number'

export const Postive = styled.div`
  color: #00c087;
  display: flex;
  justify-content: flex-end;
`

export const Negative = styled.div`
  color: ${({ theme }) => theme.down};
  display: flex;
  justify-content: flex-end;
`

const NonValue = styled.div`
  justify-content: flex-end;
  text-indent: 40px;
`

export default class Change extends PureComponent {
  static propTypes = {
    change: PropTypes.number,
  }

  static defaultProps = {
    change: '-',
  }

  _renderChange(change) {
    if (change === '-') return <NonValue>-</NonValue>
    if (parseFloat(change, 10) === 0) {
      return <Postive>{pencentage(parseFloat(change, 10), 1)}</Postive>
    }
    return change > 0 ? (
      <Postive>{`+${pencentage(parseFloat(change, 10), 1)}`}</Postive>
    ) : (
      <Negative>
        {`-${
          pencentage(parseFloat(change, 10), 1) === '100.00%'
            ? '99.99%'
            : pencentage(parseFloat(change, 10), 1)
        }`}
      </Negative>
    )
  }

  render() {
    const { change } = this.props
    return this._renderChange(change)
  }
}
